:host {
  display: inline;
  --spw-link-color: var(--spw-ds-primary);
  --spw-link-hover-color: var(--spw-ds-variant);
  --spw-link-active-color: var(--spw-ds-active);
  --spw-link-padding: 6px;
}

.spw-link {
  display: inline;
  text-decoration: none;
  cursor: pointer;
  color: var(--spw-link-color);
  border-radius: 4px;
  font-weight: 700;
  &--surface-dark {
    color: var(--spw-ds-white);
  }

  &__inner {
    display: inline;
    border-bottom: 1px solid var(--spw-link-color);
    .spw-link--surface-dark & {
      border-bottom: 1px solid var(--spw-ds-white);
    }
  }

  &:focus-visible {
    outline-offset: 1px;
    outline: 2px solid var(--spw-ds-focus);
  }

  &:hover {
    color: var(--spw-link-hover-color);
    .spw-link__inner {
      border-bottom: 2px solid var(--spw-link-hover-color);
    }
  }

  &:active {
    color: var(--spw-link-active-color);
    .spw-link__inner {
      border-bottom: 2px solid var(--spw-link-active-color);
    }
  }

  &[aria-disabled='true'] {
    pointer-events: none;
    color: var(--spw-color-themes-grey-grey-600);
    cursor: not-allowed;
  }

  &--surface-dark {
    &:hover {
      color: var(--spw-ds-white);
      .spw-link__inner {
        border-bottom: 2px solid var(--spw-ds-white);
      }
    }

    &:active {
      color: var(--spw-ds-white);
      .spw-link__inner {
        border-bottom: 2px solid var(--spw-ds-white);
      }
    }

    &[aria-disabled='true'] {
      color: var(--spw-ds-white);
      opacity: 0.5;
    }
  }

  &--has-icon-right spw-icon {
    margin-left: var(--spw-link-padding);
    margin-right: 4px;
  }

  &--has-icon-left spw-icon {
    margin-left: 4px;
    margin-right: var(--spw-link-padding);
  }
}
